module.exports = {
  checkDetail: {
    'zh-CN': '查看详情',
	'zh-TW': '查看詳情',
    'en-US': 'Check Detail',
    'th-TH': 'Check Detail',
    'vi-VN': 'Check Detail'
  },
  novenTitle1: {
    'zh-CN': '銳意革新 拒絕相似！',
    'zh-TW': '銳意革新 拒絕相似！',
    'en-US': '銳意革新 拒絕相似！',
    'th-TH': '銳意革新 拒絕相似！',
    'vi-VN': '銳意革新 拒絕相似！'
  },
  novenTitle2: {
    'zh-CN': '《諾文尼亞》RPG與連珠的完美結合！',
    'zh-TW': '《諾文尼亞》RPG與連珠的完美結合！',
    'en-US': '《諾文尼亞》RPG與連珠的完美結合！',
    'th-TH': '《諾文尼亞》RPG與連珠的完美結合！',
    'vi-VN': '《諾文尼亞》RPG與連珠的完美結合！'
  },
  novenContent: {
    'zh-CN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
    'zh-TW': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
    'en-US': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
    'th-TH': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！',
    'vi-VN': '2018開年鉅作，日式RPG奇幻冒險與連珠消除完美結合的【諾文尼亞】來啦！多位超一線聲優傾情助陣！宏大世界觀顛覆想象！多重連珠爽快Combo！快來一起體驗獨特連珠RPG的爽快戰鬥吧！'
  },
  bhmtTitle1: {
    'zh-CN': 'MMORPG鉅作《巴哈姆特之魂》',
	'zh-TW': 'MMORPG鉅作《巴哈姆特之魂》',
    'en-US': 'MMORPG鉅作《巴哈姆特之魂》',
    'th-TH': 'MMORPG鉅作《巴哈姆特之魂》',
    'vi-VN': 'MMORPG鉅作《巴哈姆特之魂》'
  },
  bhmtTitle2: {
    'zh-CN': '火爆空降雙端榜單前列',
	'zh-TW': '火爆空降雙端榜單前列',
    'en-US': '火爆空降雙端榜單前列',
    'th-TH': '火爆空降雙端榜單前列',
    'vi-VN': '火爆空降雙端榜單前列'
  },
  jwsTitle1: {
    'zh-CN': '熱血最強ARPG《極無雙》',
	'zh-TW': '熱血最強ARPG《極無雙》',
    'en-US': '熱血最強ARPG《極無雙》',
    'th-TH': '熱血最強ARPG《極無雙》',
    'vi-VN': '熱血最強ARPG《極無雙》'
  },
  jwsTitle2: {
    'zh-CN': '暢爽無雙完美復刻',
	'zh-TW': '暢爽無雙完美復刻',
    'en-US': '暢爽無雙完美復刻',
    'th-TH': '暢爽無雙完美復刻',
    'vi-VN': '暢爽無雙完美復刻'
  },
  jwsContent: {
    'zh-CN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
	'zh-TW': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
    'en-US': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
    'th-TH': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！',
    'vi-VN': '致敬經典，暢爽掌中無雙體驗！採用最新引擎打造的《極無雙》將為你還原熱血的三國戰場。宏大的場景，華麗的技能。用最輕鬆地操作打出最華麗的Combo，萬人同屏，千人連斬！'
  },
  bhmtContent: {
    'zh-CN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
	'zh-TW': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
    'en-US': "全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！",
    'th-TH': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！',
    'vi-VN': '全球首款人龍合體魔幻變身3D MMORPG震撼來襲上古龍神巴哈姆特滅世降臨 世界處於崩壞邊緣龍裔們！化身為龍守護世界！'
  },
  appTitle1: {
    'zh-CN': '《天域战记》全新銅像玩法',
	'zh-TW': '《天域战记》全新銅像玩法',
    'en-US': '《天域战记》全新銅像玩法',
    'th-TH': '《天域战记》全新銅像玩法',
    'vi-VN': '《天域战记》全新銅像玩法'
  },
  appDesc1: {
    'zh-CN': '挑戰克隆傭兵，提升戰力！',
	'zh-TW': '挑戰克隆傭兵，提升戰力！',
    'en-US': '挑戰克隆傭兵，提升戰力！',
    'th-TH': '挑戰克隆傭兵，提升戰力！',
    'vi-VN': '挑戰克隆傭兵，提升戰力！'
  },
  appTitle2: {
    'zh-CN': '《巴哈姆特之魂》震撼上线',
	'zh-TW': '《巴哈姆特之魂》震撼上线',
    'en-US': '《巴哈姆特之魂》震撼上线',
    'th-TH': '《巴哈姆特之魂》震撼上线',
    'vi-VN': '《巴哈姆特之魂》震撼上线'
  },
  appDesc2: {
    'zh-CN': '即時PK、天梯排位，你能否傲視群雄？',
	'zh-TW': '即時PK、天梯排位，你能否傲視群雄？',
    'en-US': '即時PK、天梯排位，你能否傲視群雄？',
    'th-TH': '即時PK、天梯排位，你能否傲視群雄？',
    'vi-VN': '即時PK、天梯排位，你能否傲視群雄？'
  },
  lunaTitle1: {
    'zh-CN': 'Q 版MMORPG神作復活！',
	'zh-TW': 'Q 版MMORPG神作復活！',
    'en-US': 'Q 版MMORPG神作復活！',
    'th-TH': 'Q 版MMORPG神作復活！',
    'vi-VN': 'Q 版MMORPG神作復活！'
  },
  lunaTitle2: {
    'zh-CN': '《Luna M（首部曲）》萌動歸來！',
	'zh-TW': '《Luna M（首部曲）》萌動歸來！',
    'en-US': '《Luna M（首部曲）》萌動歸來！',
    'th-TH': '《Luna M（首部曲）》萌動歸來！',
    'vi-VN': '《Luna M（首部曲）》萌動歸來！'
  },
  lunaContent: {
    'zh-CN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
	'zh-TW': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
    'en-US': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
    'th-TH': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~',
    'vi-VN': '時隔十年，經典线上游戏《LUNA ONLINE》正統續作歸來！《Luna M（首部曲）》完美復刻原作玩法，將經典LUNA帶進手機！次時代引擎打造，畫質全面升級，讓你更萌更可愛！新增多種強大社交功能，交友、結婚、合作、競爭，讓你終結孤單！《Luna M》可愛再升級！啾咪~'
  },
  getLiked: {
    'zh-CN': ' 人点赞',
	'zh-TW': ' 人点赞',
    'en-US': ' 人点赞',
    'th-TH': ' 人点赞',
    'vi-VN': ' 人点赞'
  },
  recentNews: {
    'zh-CN': '最新资讯',
	'zh-TW': '最新資訊',
    'en-US': 'Latest News',
    'th-TH': 'Latest News',
    'vi-VN': 'Latest News'
  },
  aboutCompany: {
    'zh-CN': '公司介绍',
	'zh-TW': '公司介紹',
    'en-US': 'About Company',
    'th-TH': 'About Company',
    'vi-VN': 'About Company'
  },
  boutique: {
    'zh-CN': '精品',
	'zh-TW': '精品',
    'en-US': 'With competitive products',
    'th-TH': 'With competitive products',
    'vi-VN': 'With competitive products'
  },
  boutiqueDesc: {
    'zh-CN': '所发游戏多次被谷歌／ios推荐',
	'zh-TW': '所發遊戲多次被谷歌/ios推薦',
    'en-US': 'Our games have been featured repeatedly by Google Play and App Store',
    'th-TH': 'Our games have been featured repeatedly by Google Play and App Store',
    'vi-VN': 'Our games have been featured repeatedly by Google Play and App Store'
  },
  professional: {
    'zh-CN': '专业',
	'zh-TW': '專業',
    'en-US': 'Professional',
    'th-TH': 'Professional',
    'vi-VN': 'Professional'
  },
  professionalDesc: {
    'zh-CN': '零运营事故',
	'zh-TW': '零運營事故',
    'en-US': 'No operational accident',
    'th-TH': 'No operational accident',
    'vi-VN': 'No operational accident'
  },
  fast: {
    'zh-CN': '快速',
	'zh-TW': '快速',
    'en-US': 'With high-speed',
    'th-TH': 'With high-speed',
    'vi-VN': 'With high-speed'
  },
  fastDesc: {
    'zh-CN': '半年内上线全球',
	'zh-TW': '半年內上線全球',
    'en-US': 'Launch one game worldwide within six months',
    'th-TH': 'Launch one game worldwide within six months',
    'vi-VN': 'Launch one game worldwide within six months'
  },
  hotGames: {
    'zh-CN': '热门游戏',
	'zh-TW': '熱門遊戲',
    'en-US': 'Hot Games',
    'th-TH': 'Hot Games',
    'vi-VN': 'Hot Games'
  },
  partner: {
    'zh-CN': '合作伙伴',
	'zh-TW': '合作夥伴',
    'en-US': 'Partner',
    'th-TH': 'Partner',
    'vi-VN': 'Partner'
  },
  gameType: {
    'zh-CN': '游戏类型',
	'zh-TW': '遊戲類型',
    'en-US': 'Type',
    'th-TH': 'Type',
    'vi-VN': 'Type'
  },
  gameRating: {
    'zh-CN': '游戏评分',
	'zh-TW': '遊戲評分',
    'en-US': 'Rating',
    'th-TH': 'Rating',
    'vi-VN': 'Rating'
  },
  goToSite: {
    'zh-CN': '进入官网',
	'zh-TW': '進入官網',
    'en-US': 'Official Site',
    'th-TH': 'Official Site',
    'vi-VN': 'Official Site'
  },
  changeGames: {
    'zh-CN': '换一批',
	'zh-TW': '換一批',
    'en-US': 'Change Games',
    'th-TH': 'Change Games',
    'vi-VN': 'Change Games'
  },
  typeNews: {
    'zh-CN': '新闻',
	'zh-TW': '新聞',
    'en-US': 'News',
    'th-TH': 'News',
    'vi-VN': 'News'
  }
};



// WEBPACK FOOTER //
// ./src/lang/home.js